/** How a quote's tax is shown: the rows and legal note the server decided for seller and buyer. */

/** Tax rows exactly as the server worked them out for this seller and buyer. */
export function taxLines(q: { tax_lines: { label: string; amount: number }[]; tax_mode_label: string }): [string, number][] {
  return q.tax_lines.length ? q.tax_lines.map((t) => [t.label, t.amount]) : [[`Tax: ${q.tax_mode_label}`, 0]];
}

export function TaxNote({ note, label }: { note: string | null; label: string }) {
  if (!note) return null;
  return (
    <p className="ml-auto mt-3 max-w-sm rounded-md bg-canvas px-3 py-2 text-xs text-muted" data-testid="tax-note">
      <span className="font-medium text-ink">{label}.</span> {note}
    </p>
  );
}
